// Dependencies.
let FieldUtility = require("./utils/Fcbtfield");

function RenderFcbtRange(fieldData, fieldValidators, cssClasses) {

    FieldUtility.initializeField(this, fieldData, fieldValidators, {
        type: "range",
        cssClasses: cssClasses
    });
    
    this.element.setAttribute("min", fieldData.configuration.min);
    this.element.setAttribute("max", fieldData.configuration.max);
    this.element.setAttribute("step", fieldData.configuration.step);
    this.element.setAttribute("value", fieldData.configuration.initial);        
}

RenderFcbtRange.prototype.getElement = function () {
    return this.wrapper;
};

RenderFcbtRange.prototype.setData = function (data, options) {
    FieldUtility.setData(data, this.element.value, options, this.alias, this.id);
};

RenderFcbtRange.prototype.checkValidity = function () {
    return require("/App_Plugins/formulate/templates/responsive.plain-javascript/utils/validation")
        .checkTextValidity(this, this.validators, this.element.value, this.wrapper);
};

FieldUtility.initializeFieldPrototype(RenderFcbtRange.prototype);

// Store the field renderer configuration on the window so Formulate can access it.
let key = "formulate-plain-js-fields";
window[key] = window[key] || [];
window[key].push({
    key: "RangeField",
    renderer: RenderFcbtRange
});

